<script setup>
import UTAFirmwares from '@/components/UTAFirmwares.vue'
</script>

<template>
    <div class="page page--firmwares">
        <UTAFirmwares />
    </div>
</template>
